module.exports = __webpack_public_path__ + "static/media/icon-receive-with-border.a28e2bb8.svg";